import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// component
import { LoadingScreen, RejectScreen } from "../../component/loading";
import { routerPublict } from "./route/router_publict";
import { routerPrivate } from "./route/router_private";
// redux
import { logOut, snapAuth, unSnapAuth } from "../../store/auth/auth.action";
import { isLoggedSelector } from "../../store/auth/auth.selector";
import { snapUser, unSnapUser } from "../../store/user/user.action";
import { snapOwner, unSnapOwner } from "../../store/role/role.action";
import { snapStaff, unSnapStaff } from "../../store/staff/staff.action";
import { getAuth } from "firebase/auth";
import { app } from "../../config/config";
import { isOwnerSelector } from "../../store/role/role.selector";
import { message } from "antd";

const auth = getAuth(app);
const Router = () => {
  // -------------------------- STATE --------------------------
  const logged = useSelector(isLoggedSelector);
  const isOwner = useSelector(isOwnerSelector);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // check snap auth for users
  useEffect(() => {
    dispatch(snapAuth());
    return () => {
      dispatch(unSnapAuth());
    };
  }, [dispatch]);

  // if logged in check user info
  useEffect(() => {
    if (logged) {
      dispatch(snapUser());
      dispatch(snapOwner());
      dispatch(snapStaff());
    }
    return () => {
      dispatch(unSnapUser());
      dispatch(unSnapOwner());
      dispatch(unSnapStaff());
    };
  }, [dispatch, logged]);

  // -------------------------- MAIN --------------------------
  if (logged === null || isOwner === null) {
    return <LoadingScreen />;
  }

  if (logged && isOwner === false) {
    return <RejectScreen />;
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Navigate to="/" />} />
        {logged ? routerPrivate() : routerPublict()}
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
